import * as React from "react";
import { Button, FloatingLabel, Form, Modal } from "react-bootstrap";
import { useBackButton } from "src/hooks/useBackButton";
import type { CategoryNode } from "@iterate/common/types/shared";

interface Props {
  category: CategoryNode;
  onChange(category: CategoryNode): void;
  onSave(): void;
  onCancel(): void;
}

export function CategoryForm({ category, onChange, onSave, onCancel }: Props) {
  useBackButton(onCancel);
  const [budgetStr, setBudgetStr] = React.useState(category.budget?.toFixed(2) ?? "");
  const setField = <K extends keyof CategoryNode>(key: K, value: CategoryNode[K]) => {
    onChange({ ...category, [key]: value });
  };

  const setBudget = (budgetStr: string) => {
    setBudgetStr(budgetStr);
    if (budgetStr === "") {
      setField("budget", null);
    } else {
      const budget = parseFloat(budgetStr);
      setField("budget", budget);
    }
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    onSave();
  };

  return (
    <Modal show onHide={onCancel}>
      <Form onSubmit={onSubmit}>
        <Modal.Body>
          <FloatingLabel label="Name" className="mb-3">
            <Form.Control
              autoFocus
              value={category.name ?? ""}
              onChange={(e) => setField("name", e.target.value)}
            />
          </FloatingLabel>
          <FloatingLabel label="Budget" className="mb-3">
            <Form.Control value={budgetStr} onChange={(e) => setBudget(e.target.value)} />
          </FloatingLabel>
          <Button
            type="submit"
            onClick={onSubmit}
            disabled={category.budget !== null && isNaN(category.budget)}
          >
            Save Category
          </Button>
        </Modal.Body>
      </Form>
    </Modal>
  );
}
